export const propertyTypes = [
  {
    label: "House",
    value: "house",
    key: "house",
  },
  {
    label: "Land",
    value: "land",
    key: "land",
  },
  {
    label: "Apartment",
    value: "apartment",
    key: "apartment",
  },
  {
    label: "Commercial Property",
    value: "commercial property",
    key: "commercial property",
  },
  {
    label: "Villa / Bungalow",
    value: "villa / bungalow",
    key: "villa / bungalow",
  },
  {
    label: "Hotel",
    value: "hotel",
    key: "hotel",
  },
];

export const furnitureTypes = [
  {
    label: "Furnished",
    value: "furnished",
    key: "furnished",
  },
  {
    label: "Unfurnished",
    value: "unfurnished",
    key: "unfurnished",
  },
  {
    label: "Semi Furnished",
    value: "semi furnished",
    key: "semi furnished",
  },
];

export const pervalTypes = [

  {
    label: "Per Month",
    value: "per month",
    key: "per month",
  },
  {
    label: "Per Year",
    value: "per year",
    key: "per year",
  },
  {
    label: "Per Week",
    value: "per week",
    key: "per week",
  },
  {
    label: "Per Day",
    value: "per day",
    key: "per day",
  },
  {
    label: "Per Hour",
    value: "per hour",
    key: "per hour",
  },
  {
    label: "Per Sqft",
    value: "per sqft",
    key: "per sqft",
  },

  {
    label: "Per Desk",
    value: "per desk",
    key: "per desk",
  },
    
  
];

export const booleanTypes = [
  {
    label: "Yes",
    value: "yes",
    key: "yes",
  },
  {
    label: "No",
    value: "no",
    key: "no",
  },
];

export const listingTypes = [
  {
    label: "Sell",
    value: "sell",
    key: "sell",
  },
  {
    label: "Rent",
    value: "rent",
    key: "rent",
  },
];

export const userRoles = [
  {
    key: "super admin",
    label: "Super Admin",
    value: "super admin",
  },
  {
    key: "admin",
    label: "Admin",
    value: "admin",
  },
  {
    key: "user",
    label: "User",
    value: "user",
  },
];

export const propertyAgeType = [
  {
    label: "Brand New",
    value: "brand new",
    key: "brand new",
  },
  {
    label: "Less than 5 years",
    value: "less than 5 years",
    key: "less than 5 years",
  },
  {
    label: "Less than 10 years",
    value: "less than 10 years",
    key: "less than 10 years",
  },
  {
    label: "More than 10 years",
    value: "more than 10 years",
    key: "more than 10 years",
  },
];

export const measuringUnitType = [
  {
    label: "Acres",
    value: "acres",
    key: "acres",
  },
  {
    label: "Perches",
    value: "perches",
    key: "perches",
  },
];

export const amenityType = [
  {
    label: "Water",
    value: "water",
    id: "water",
    key: "water",
  },
  {
    label: "Electricity",
    value: "electricity",
    id: "electricity",
    key: "electricity",
  },
  {
    label: "telephone",
    value: "telephone",
    id: "telephone",
    key: "telephone",
  },
];

export const visibilityTypes = [
  {
    label: "On",
    value: "on",
    key: "on",
  },
  {
    label: "Off",
    value: "off",
    key: "off",
  },
];
